module.exports = { 
      attributes: {"title":"Sommerfest der Deutsch­-Japanischen Gesellschaft","date":"2018-07-08T00:00:00.000Z","author":"O. R.","categories":["news"],"tags":["news"],"language":"de","section":null},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = function render() { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body"},[_c('p',[_vm._v("Am 30. Juni 2018 fand in einer Villa im Berliner Stadtteil Dahlem das\ndiesjährige Sommerfest der Deutsch-­Japanischen Gesellschaft statt.")]),_vm._v(" "),_c('p',[_vm._v("Die Begrüßung bei meiner Ankunft war festlich!\nEin deutsch­-japanischer Chor sang im Treppenhaus\njapanische und deutsche Lieder zur Klavierbegleitung.")]),_vm._v(" "),_c('image-reel',[_vm._v("\nSommerfest Chor|/sommerfest2018/chor_h200.jpg\nSommerfest Shogistand|/sommerfest2018/shogi-stand_h200.jpg\n")]),_vm._v(" "),_vm._m(0)],1) };
            this.$options.staticRenderFns = [function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Den vollständigen Bericht als PDF finden Sie "),_c('a',{attrs:{"href":"/sommerfest2018/Sommerfest.pdf"}},[_vm._v("hier")]),_vm._v(".")]) }];
          }
        }
      },
     }